/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
var books = require('./avayawebrtc-client');


console.log("Modify by GNP - ClickToCall");
/*
 *
 ******************************VARIABLES****************************************
 *
 */
var phoneRinging = 0;
var myInterval;
var GLOBAL_NOMBRE = "";
var GLOBAL_TELEFONO = "";
var GLOBAL_CLIENTE = "";
var GLOBAL_RAMO = "";
var GLOBAL_GROUP = "0990";
var GLOBAL_MOTIVO = "";
var GLOBAL_USERNAME = "4300";
var GLOBAL_CONTEXT;
var GLOBAL_NOMBRE;

var FQDN = "webcall.gnp.com.mx";
//"10.67.91.198";
//"breeze2-196.collaboratory.avaya.com";

/*
 *
 ******************************EVENTOS******************************************
 *
 */

var _call = window._call || {};

(function (window){

    var absolutepath = getAbsolutePath();
    //html methods
    _call["clickToCall"] = function(nombre, cliente, ramo, telefono){
        this.GLOBAL_CLIENTE = cliente;
        this.GLOBAL_MOTIVO = document.getElementById("click2callCmbId").value;

        if(ramo === ""){
            ramo = "Todas";
            GLOBAL_GROUP = "0990";
        }
        if(ramo === "Autos"){
            GLOBAL_GROUP = "0980";
        }
        if(ramo.includes("Gastos")){
            ramo = "GMM";
            GLOBAL_GROUP = "0981";
        }
        if(ramo === "Vida"){
            GLOBAL_GROUP = "0982";
        }
        if(ramo === "Daños"){
            ramo = "Danos";
            GLOBAL_GROUP = "0983";
        }
        

        GLOBAL_CONTEXT = cliente+'/'+ramo+'/'+this.GLOBAL_MOTIVO+'/'+nombre;

        console.log(GLOBAL_CONTEXT);

        changePhoneIcon();
        modificarTelefono(telefono);
        continuarConWebRTC(nombre);
    };

/*
 *
 * *****************************FUNCIONES***************************************
 *
 */

function modificarTelefono(telefono) {
    var telefonoCollaboratory = telefono;
    console.log(telefonoCollaboratory);

        var data = null;

        var xhr = new XMLHttpRequest();
        xhr.withCredentials = false;

        xhr.addEventListener("readystatechange", function () {
            if (this.readyState === 4) {
                console.log(this.responseText);
                var jsonObject = JSON.parse(this.responseText);

                if (jsonObject.status === "ok") {
                    GLOBAL_TELEFONO = telefonoCollaboratory;
                }
                if (jsonObject.status === "error") {
                        console.log("Error telefono");
                }

            }
        });

        xhr.open("POST", "https://"+FQDN+"/services/AAADEVWebRTCGNP/TelefonoEndPoint?telefono=" + GLOBAL_GROUP);
        xhr.send(data);

}

    function continuarConWebRTC(name) {
        var nombre = name;
        console.log("Noombre:: " + nombre);

        if (nombre === "" || nombre === null) {
           console.log("Noombre invalido");
        } else {

            var data = null;

            var xhr = new XMLHttpRequest();
            xhr.withCredentials = false;

            xhr.addEventListener("readystatechange", function () {
              if (this.readyState === 4) {
                console.log(this.responseText);
                var jsonObject = JSON.parse(this.responseText);
                if(jsonObject.status === "ok"){
                    changePhoneIcon();
                    GLOBAL_NOMBRE = nombre;
                }
                if(jsonObject.status === "error"){
                	console.log("Error, favor de intentar de nuevo");
                }

              }
            });

            console.log(GLOBAL_CONTEXT.substring(32,46));
            xhr.open("POST", "https://"+FQDN+"/services/AAADEVWebRTCGNP/Authorization?nombre="+GLOBAL_CONTEXT.substring(32,46));
            xhr.send(data);

        }
    }

function changePhoneIcon() {

    if (phoneRinging === 0) {

        document.querySelector('#click2CallBtnId').innerHTML = 'Llamando...';
        document.querySelector('#cancel2CallBtnId').innerHTML = 'Cancelar';
        document.querySelector('#cancel2CallBtnId').style.display = 'block';
        startWebRTC();
        phoneRinging++;
    }
}


function getAbsolutePath() {
    var loc = window.location;
    var pathName = loc.pathname.substring(0, loc.pathname.lastIndexOf('/') + 1);
    return loc.href.substring(0, loc.href.length - ((loc.pathname + loc.search + loc.hash).length - pathName.length));
}

function changePhoneIcon() {

    if (phoneRinging === 0) {

        document.querySelector('#click2CallBtnId').innerHTML = 'Llamando...';
        document.querySelector('#cancel2CallBtnId').innerHTML = 'Cancelar';
        document.querySelector('#cancel2CallBtnId').style.display = 'block';

        startWebRTC();
        phoneRinging++;
    }
}


function getAbsolutePath() {
    var loc = window.location;
    var pathName = loc.pathname.substring(0, loc.pathname.lastIndexOf('/') + 1);
    return loc.href.substring(0, loc.href.length - ((loc.pathname + loc.search + loc.hash).length - pathName.length));
}


function startWebRTC() {

    var client;
    var theCall;
    client = new books.avayaWebRTC.Client();
    console.log(client);
    client.enableLogs = books.avayaWebRTC.LOG_ENABLE_FULL;


    //SET Call Backs
    client.onConnectedCB = connectedCB;
    client.onDisconnectedCB = disconnectedCB;
    client.onNotificationCB = notificationCB;
    client.onCallConnectedCB = onCallConnectedCB;
    client.onCallInitiatingCB = onCallInitiatingCB;
    client.onCallRingingCB = onCallRingingCB;
    client.onCallRemoteDisconnectedCB = onCallRemoteDisconnectedCB;
    client.onCallErrorCB = onCallErrorCB;
    client.onRemoteMediaConnectedCB = onRemoteMediaConnectedCB;
    //Configure client and connect
    client.webRTCHTTPAddress = "https://"+FQDN+":443/services/WebRTC/WebRtcServlet";

    var data = null;
    var xhr = new XMLHttpRequest();
    xhr.withCredentials = true;

    xhr.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
            console.log("Token");
            console.log(this.readyState);
            client.securityToken = this.responseText;
            client.username = GLOBAL_USERNAME;
            client.domain = "gnp.mx";
            client.connect();

        }
    });

    xhr.open("GET", "https://"+FQDN+"/services/AAADEVWebRTCGNP/Authorization");
    xhr.send(data);




    //callBack notificationCB
    function notificationCB(code, reason, severity, description) {
        console.log("notificationCB");
        //some error notification may signify that method parameter callbacks will not fire. You will be able to stop processing
        console.log(code);
        switch (code) {
            case books.avayaWebRTC.ERR_CLIENT_ERROR:
                //some called methods may not success and will not call for callbacks.
                console.log(reason);
                switch (reason) {
                    case books.avayaWebRTC.ERR_REASON_NOT_CONNECTED:
                    case books.avayaWebRTC.ERR_REASON_SOCKET_ERROR:
                        //connect/disconnect will not return callback in such case
                        console.log("onnect/disconnect will not return callback in such case")
                        break;
                }
                break;
            case books.avayaWebRTC.ERR_SERVER_ERROR_CONNECTION_FAILED:
            case books.avayaWebRTC.ERR_SERVER_ERROR_DISCONNECT_FAILED:
                console.log("notificationCB")
                break;
        }
    }

    //callBack disdisconnectedCB
    function disconnectedCB() {
        console.log("disconnectedCB");

        //this callback audits for client disconnected event
        console.log(books.avayaWebRTC.CLIENT_NOTIFICATION_INFO + ' Client is disconnected successfully');

        document.querySelector('#click2CallBtnId').innerHTML = 'Llamanos';
        document.querySelector('#cancel2CallBtnId').style.display = 'none';
//        var iconoUnoImgTextNode = document.createTextNode(" LLAMANOS");


    }

    //callback is invoked
    function connectedCB() {
        console.log("connectedCB");
        console.log("GLOBAL_GROUP:" + GLOBAL_GROUP);
        theCall = new books.avayaWebRTC.Call(client);
        theCall.ringingFileUrl = "https://"+FQDN+"/services/WebRTCSampleApplication/img/ringout.wav";
        theCall.destinationAddress = GLOBAL_GROUP + "@gnp.mx";
        console.log(GLOBAL_CONTEXT.substring(0, 31));
        theCall.ContextID = GLOBAL_CONTEXT.substring(0, 31);
        theCall.initiate();
    }
    //callback is invoked
    function onCallInitiatingCB(call) {
        console.log("onCallInitiatingCB");

        //var textoIconoDosTextNode = document.createTextNode(" INITIATING");

    }
    //callback is invoked after call is launched to called party and that party is alerting
    function onCallRingingCB(call) {
        console.log("onCallRingingCB");
        //callback audits for ringing on remote party event
        console.log(books.avayaWebRTC.CLIENT_NOTIFICATION_INFO.toString() + ' Call is ringing the remote side');

        //var textoIconoDosTextNode = document.createTextNode(" RINGING");

    }
    //Is invoked when receiving media from far end. Ringing file is stopped.
    function onRemoteMediaConnectedCB(call, code, reason, description) {
        console.log("onRemoteMediaConnectedCB");
        //callback audits for call remote party media connected
        console.log(books.avayaWebRTC.CLIENT_NOTIFICATION_INFO + ' Call remote media is started.');
    }

    function onCallConnectedCB(call) {
        console.log("onCallConnectedCB");
        //this callback audits for call connection event
        console.log(true, books.avayaWebRTC.CLIENT_NOTIFICATION_INFO.toString() + ' Call is connected successfully');

        document.querySelector('#click2CallBtnId').innerHTML = 'Conectado';
        document.querySelector('#cancel2CallBtnId').innerHTML = 'Colgar';

        var energyCollector = setInterval(function () {
            //start interval to get energy level and paint it in canvas
            if (!call)
                return;
            if (call.callState !== books.avayaWebRTC.CALL_STATE_CONNECTED) {
                return;
            }
            //energy
            var microphoneLevels = call.microphoneLevels;
            console.log(microphoneLevels);
        }, 300);
    }

    _call["cancelCall"] = function() {
        //drop connected call
        if (!theCall || theCall.callState === books.avayaWebRTC.CALL_STATE_IDLE) {
            return;
        }
        theCall.drop();

        document.querySelector('#click2CallBtnId').innerHTML = 'Llamanos';
        document.querySelector('#cancel2CallBtnId').style.display = 'none';

        phoneRinging = 0;
    }

    function onCallRemoteDisconnectedCB(call) {
        console.log("onCallRemoteDisconnectedCB");
        //callback audits for call disconnected event by remote party
        console.log(books.avayaWebRTC.CLIENT_NOTIFICATION_INFO + ' Call is disconnected');
        call.destroy();
        theCall = undefined;
        client.disconnect();

        document.querySelector('#click2CallBtnId').innerHTML = 'Llamanos';
        phoneRinging = 0;
    }

    function onCallErrorCB(call, code, reason, description) {
        console.log("onCallErrorCB");
        console.log("Error on Call");
        //callback audits for call error events
        console.log(books.avayaWebRTC.CLIENT_NOTIFICATION_ERROR + " " + description);
        switch (code)
        {
            case books.avayaWebRTC.CALL_ERROR_INITIATE_FAILED:
                console.log("CALL ERROR INITIATE FAILED");
                call.destroy();
                theCall = undefined;
                client.disconnect();
        }

        document.querySelector('#click2CallBtnId').innerHTML = 'Llamanos';
        document.querySelector('#cancel2CallBtnId').style.display = 'none';
//        var iconoUnoImgTextNode = document.createTextNode(" LLAMANOS");

        phoneRinging = 0;
    }
}


    window["_call"] = _call;
}) (window);


/**********************************************************************************************************/
//internal utils
/**********************************************************************************************************/
function getScriptBasicUrl(scriptName) {
    var scriptElements = document.getElementsByTagName('script');
    var counter, element, myfile;
    var scriptsBasicUrl = "";
    for (counter = 0; element = scriptElements[counter]; counter++) {
        myfile = element.src;
        if (myfile.indexOf(scriptName) >= 0) {
            scriptsBasicUrl = myfile.substring(0, myfile.indexOf(scriptName));
            break;
        }
    }
    return scriptsBasicUrl;
}



// WEBPACK FOOTER //
// ./src/call/clickToCall.js